module.exports = __webpack_public_path__ + "static/media/transport-travel.52819483.svg";